import {
  QueryClientProvider,
  WebApiProvider,
  type QueryClient,
  type WebApi,
} from '@care-platform/api-client';
import { TooltipProvider } from '@care-platform/ui';
import type { ReactNode } from 'react';
import { CopyProvider } from './copy';
import type { Copy } from './copy/en';
import { RouteRegistryProvider } from './routing/context';
import type { RouteRegistry } from './routing/registry';

/** The providers every web shell needs around its router, in one place. */
export function ShellProviders({
  api,
  queryClient,
  registry,
  copy,
  children,
}: {
  api: WebApi;
  queryClient: QueryClient;
  registry: RouteRegistry;
  copy?: Copy;
  children: ReactNode;
}) {
  return (
    <CopyProvider copy={copy}>
      <QueryClientProvider client={queryClient}>
        <WebApiProvider api={api}>
          <RouteRegistryProvider registry={registry}>
            <TooltipProvider>{children}</TooltipProvider>
          </RouteRegistryProvider>
        </WebApiProvider>
      </QueryClientProvider>
    </CopyProvider>
  );
}
